import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { environment } from '@env/environment';
import { SimplyBenefitsService } from '../services/simply-benefits.service';

@Component({
    template: `<div class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>`,
})
export class EmployeePortalRedirectView implements OnInit {
    constructor(
        private auth: AuthService,
        private notify: NotifyService,
        private simplyBenefitsService: SimplyBenefitsService,
        private router: Router,
        private analyticsService: AnalyticService
    ) {}

    async ngOnInit(): Promise<void> {
        const originalUrl = environment.simplyBenefitsEmployeePortalUrl;
        const token = await this.getNewMemberToken();
        if (!token || !originalUrl) {
            return;
        }

        this.analyticsService.trackEvent(AnalyticEvents.SimplyBenefitsAccessEmployeePortal);
        const endpointWithToken = '/dashboard?token=' + token;
        window.location.href = originalUrl.replace('/login', endpointWithToken);
    }

    private async getNewMemberToken(): Promise<string> {
        try {
            return await this.simplyBenefitsService.getNewMemberToken(this.auth.employee.id);
        } catch (error) {
            if (error.status == 403) {
                this.notify.error('components.benefitsEmployeePortalRedirect.permissionLimit');
                this.router.navigate(['/forbidden']);
            } else {
                this.notify.error('components.benefitsEmployeePortalRedirect.loadError');
                this.router.navigate(['/server-error']);
            }
            return '';
        }
    }
}
